"use strict";
/// <reference path="./Workflow.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
require("babel-polyfill");
let $ = require("jquery");
require("@progress/kendo-ui");
let _ = require("underscore");
const Utilities_1 = require("../../javascript/Utilities");
const WorkflowManager_1 = require("./WorkflowManager");
require("./Workflow.less");
const WorkflowModel_1 = require("./WorkflowModel");
class WorkflowImpl {
    static init($elem) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = WorkflowImpl.getData($this);
            if (!synData) {
                $this.data("synWorkflow", {});
                synData = $this.data("synWorkflow");
                $this.trigger("beginInit");
                try {
                    $this
                        .addClass("synWorkflow")
                        .trigger("initSuccess");
                }
                finally {
                    $this.trigger("endInit");
                }
            }
        });
    }
    static destroy($elem) {
        return $elem.each(function () {
            // Reset everything
            $(this)
                .removeClass("synWorkflow")
                .empty()
                .removeData("synWorkflow");
        });
    }
    static editWorkflow($elem, workflowModel, instanceId, window) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = WorkflowImpl.getData($this);
            synData.WFManager = new WorkflowManager_1.WorkflowManager($this);
            synData.WFManager.editWorkflow(workflowModel, instanceId, window);
        });
    }
    static viewWorkflow($elem, workflowModel, colorizeWorkflow, forPreview = false) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = WorkflowImpl.getData($this);
            synData.WFManager = new WorkflowManager_1.WorkflowManager($this);
            synData.WFManager.viewWorkflow(workflowModel, colorizeWorkflow, forPreview);
        });
    }
    static saveWorkflow($elem) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = WorkflowImpl.getData($this);
            if (!synData)
                return undefined;
            let wf = synData.WFManager.m_workflowModel.clone();
            wf.resolveExitList();
            Utilities_1.synUtil.getAJAXData({
                method: "PUT",
                url: Utilities_1.synUtil.getWSUrl("WorkflowSaveInstance"),
                requestData: {
                    workflow: WorkflowModel_1.WorkflowModel.toJSON(wf),
                },
                done: function (data) {
                },
                fail: function (jqXHR, textStatus, errorThrown, url) {
                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                },
                cleanUp: function () {
                }
            });
        });
    }
    static printWorkflow($elem) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = WorkflowImpl.getData($this);
            if (!synData || !synData.WFManager)
                return undefined;
            synData.WFManager.printWorkFlow();
        });
    }
    static toggleView($elem) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = WorkflowImpl.getData($this);
            if (!synData || !synData.WFManager)
                return undefined;
            synData.WFManager.toggleView();
        });
    }
    //#region Helpers
    static close($elem, checkIn) {
        let returnValue = false;
        $elem.each(function () {
            let $this = $(this);
            let synData = WorkflowImpl.getData($this);
            if (!synData)
                return undefined;
            returnValue = synData.WFManager.close(checkIn);
        });
        return returnValue;
    }
    static setData($this, data) {
        $this.data("synWorkflow", data);
    }
    static getData($this) {
        return $this.data("synWorkflow");
    }
}
WorkflowImpl.DefaultOptions = {
    WFManager: undefined,
};
(($) => {
    $.fn.synWorkflow = function () {
        // Dispatch to init function
        if (!arguments.length || typeof arguments[0] === "object")
            return WorkflowImpl.init.apply(undefined, [this].concat(Array.prototype.slice.call(arguments)));
        // Dispatch to all other functions, if they exist
        else if (typeof arguments[0] === "string" && WorkflowImpl[arguments[0]])
            return WorkflowImpl[arguments[0]].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else
            $.error("Method " + arguments[0] + " does not exist on jQuery.synWorkflow");
    };
})(jQuery);
